export const stockImageBeach = 'https://media.cntraveler.com/photos/59ef91dd8d4f736d51415c2e/master/w_2667,h_2000,c_limit/7MileBeach-2013-HiRes.jpg'

export const stockPini = 'https://havana-club.com/wp-content/uploads/2020/10/04_HC3_PINACOLADA_0275_BASE.png'